(() => {
  const initHomeHeaderState = (shell) => {
    const host = shell?.closest('.guardion-global-header-host');
    const header = shell?.querySelector('[data-guardion-global-header]');

    if (!host || !header || host.dataset.homeHeaderStateReady === 'true') return;

    host.dataset.homeHeaderStateReady = 'true';

    const isHome = shell.dataset.guardionHome === 'true';

    if (!isHome) {
      host.classList.remove('is-home-transparent');
      return;
    }

    let ticking = false;

    const update = () => {
      const stage = document.querySelector('[data-mma-home] [data-mma-stage]');

      if (!stage) {
        host.classList.remove('is-home-transparent');
        return;
      }

      const headerHeight = header.offsetHeight || 66;
      const stageBottom = stage.getBoundingClientRect().bottom;
      const shouldBeTransparent = stageBottom > headerHeight + 1;

      host.classList.toggle('is-home-transparent', shouldBeTransparent);
    };

    const scheduleUpdate = () => {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('pageshow', scheduleUpdate);
    document.addEventListener('shopify:section:load', scheduleUpdate);

    update();
  };

  const initGuardionGlobalHeader = (shell) => {
    if (!shell || shell.dataset.globalHeaderReady === 'true') return;

    const drawer = shell.querySelector('[data-guardion-global-menu]');
    const panel = drawer?.querySelector('.guardion-global-drawer__panel');
    const openButton = shell.querySelector('[data-guardion-global-menu-open]');
    const closeButtons = Array.from(
      shell.querySelectorAll('[data-guardion-global-menu-close]')
    );
    const firstFocus = shell.querySelector(
      '[data-guardion-global-menu-first-focus]'
    );

    if (!drawer || !panel || !openButton) return;

    shell.dataset.globalHeaderReady = 'true';

    initHomeHeaderState(shell);

    let previousFocus = null;

    const getFocusable = () =>
      Array.from(
        panel.querySelectorAll(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => !element.hasAttribute('inert'));

    const openMenu = () => {
      previousFocus = document.activeElement;
      drawer.removeAttribute('inert');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('guardion-global-menu-is-open');

      window.requestAnimationFrame(() => {
        firstFocus?.focus();
      });
    };

    const closeMenu = ({ restoreFocus = true } = {}) => {
      if (!drawer.classList.contains('is-open')) return;

      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('guardion-global-menu-is-open');

      if (restoreFocus && previousFocus instanceof HTMLElement) {
        previousFocus.focus();
      }

      previousFocus = null;
    };

    const handleKeydown = (event) => {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = getFocusable();
      if (!focusable.length) {
        event.preventDefault();
        panel.focus?.();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    openButton.addEventListener('click', openMenu);

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closeMenu());
    });

    drawer.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => closeMenu({ restoreFocus: false }));
    });

    document.addEventListener('keydown', handleKeydown);
  };

  const initAll = () => {
    document
      .querySelectorAll('[data-guardion-global-header-shell]')
      .forEach(initGuardionGlobalHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();